import { render, staticRenderFns } from "./commodity_add_dialog.vue?vue&type=template&id=f2c69b0c"
import script from "./commodity_add_dialog.vue?vue&type=script&lang=js"
export * from "./commodity_add_dialog.vue?vue&type=script&lang=js"
import style0 from "./commodity_add_dialog.vue?vue&type=style&index=0&id=f2c69b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports